export default __webpack_public_path__ + "static/media/O-124.bbed0c49.png";